import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=8cb11f52&"
import script from "./SelectProject.vue?vue&type=script&lang=ts&"
export * from "./SelectProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports